import React from 'react';

type TUseDimensions = { width: number; height: number };

function useRefDimensions(
  ref: React.RefObject<HTMLDivElement>
): TUseDimensions {
  const [dimensions, setDimensions] = React.useState({ width: 0, height: 0 });
  React.useEffect(() => {
    if (ref?.current) {
      const { current } = ref;
      const boundingRect = current.getBoundingClientRect();
      const { width, height } = boundingRect;
      setDimensions({ width: Math.round(width), height: Math.round(height) });
    }
  }, [ref?.current?.getBoundingClientRect()]);
  return dimensions;
}

export default useRefDimensions;
